
export default {
	// baseURL:"http://192.168.10.158:924",		
	baseURL: "https://www.xbhjng.com",		
	// baseURL_dev:"http://47.93.81.30:8909",
	baseURL_dev: "http://192.168.10.159:10002",	//开发环境接口url
	baseURL_pro: "https://www.xbhjng.com",	//生产环境接口url
	/*获取cookie*/
	getCookie: function (name) {
		var arr;
		var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
		if (arr = document.cookie.match(reg)) {
			return unescape(arr[2]);
		} else {
			return null;
		}
	},
	getUrlKey: function (name) {
		return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
	}
}



// WEBPACK FOOTER //
// ./src/components/common/js/App.js